import {_User} from "./_User";

export const UsersModulePhotoAlbumsAPI = {
    User: _User
}